import axios, { type AxiosError, type InternalAxiosRequestConfig } from "axios";

import { ensureCsrfCookie } from "./csrf";

type RetriableConfig = InternalAxiosRequestConfig & {
    _csrfRetry?: boolean;
};

export function isSessionAuthFailure(error: unknown): boolean {
    if (!axios.isAxiosError(error)) {
        return false;
    }

    const status = error.response?.status;
    const requestUrl = String(error.config?.url ?? "");
    const message =
        typeof error.response?.data?.message === "string" ? error.response.data.message : "";

    if (status === 419) {
        return false;
    }

    if (status !== 401) {
        return false;
    }

    if (requestUrl.includes("/auth/me") || requestUrl.includes("/auth/logout")) {
        return true;
    }

    if (message.toLowerCase().includes("unauthenticated")) {
        return true;
    }

    if (message.includes("Сесията е прекратена")) {
        return true;
    }

    if (message.includes("Неоторизиран")) {
        return false;
    }

    return false;
}

export async function retryRequestAfterCsrfRefresh(error: AxiosError) {
    const status = error.response?.status;
    const config = error.config as RetriableConfig | undefined;

    if (status !== 419 || !config || config._csrfRetry) {
        return null;
    }

    config._csrfRetry = true;

    try {
        await ensureCsrfCookie();
        return axios.request(config);
    } catch {
        return null;
    }
}
